import Api from '@/services/Api'

export default {

  // Método que llama a la url para crear un chat
  getPatientFpes () {
    return Api().get("/patient-fpes");
  },
  updatePatientFpe (params) {
    return Api().put("/patient-fpes",params);
  },
  addPatientFpe (params) {
    return Api().post("/patient-fpes",params);
  },
  getPatientFpe(params) {
    return Api().get("/patient-fpes/"+params);
  },
  deletePatientFpe (params) {
    return Api().delete("/patient-fpes/"+params);
  },
  getPatientFpeByRouteSheets(params){
    return Api().get("/patient-fpes-route-sheet/"+params);
  },

}



// WEBPACK FOOTER //
// ./src/services/PatientFpeService.js